import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

import { canAccessPath, pagePermission, hasPermission, homeForUser } from '../lib/permissions';

const RoleBasedRoute = ({ children, allowedRoles = [], requiredPermissions = [] }) => {
  const { pathname } = useLocation();
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const permitted = canAccessPath(user, pathname);

  if (permitted) return children;
  const home = homeForUser(user);
  return <Navigate to={home === pathname ? '/access-denied' : home} replace />;
};

export default RoleBasedRoute;
